document.documentElement.classList.add('js');
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const nav = document.querySelector('[data-mobile-nav]');
  const toggle = document.querySelector('[data-menu-toggle]');
  const closeButtons = document.querySelectorAll('[data-menu-close]');
  const closeButton = nav?.querySelector('.mobile-nav__close');
  const cookie = document.querySelector('[data-cookie-banner]');
  const setMenu = open => {
    if (!nav || !toggle) return;
    nav.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    body.classList.toggle('menu-open', open);
    if (open) closeButton?.focus();
    else if (document.activeElement && nav.contains(document.activeElement)) toggle.focus();
  };

  toggle?.addEventListener('click', () => setMenu(nav.hidden));
  closeButtons.forEach(button => button.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (nav && !nav.hidden) setMenu(false);
      else if (cookie && !cookie.hidden) {
        localStorage.setItem('waterpik-cookie-choice', 'closed');
        cookie.hidden = true;
      }
    }
    if (event.key === 'Tab' && nav && !nav.hidden) {
      const focusable = [...nav.querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled])')];
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }
  });

  const cookieChoice = localStorage.getItem('waterpik-cookie-choice');
  if (cookie && !cookieChoice) cookie.hidden = false;
  cookie?.querySelectorAll('[data-cookie-choice]').forEach(button => button.addEventListener('click', () => {
    localStorage.setItem('waterpik-cookie-choice', button.dataset.cookieChoice);
    cookie.hidden = true;
  }));

  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const renderMedia = index => {
      const thumb = thumbs[index];
      if (!thumb || !main) return;
      const image = document.createElement('img');
      image.src = thumb.dataset.mediaUrl;
      image.alt = thumb.dataset.mediaAlt || '';
      image.loading = 'eager';
      main.replaceChildren(image);
      thumbs.forEach(item => item.classList.toggle('is-active', item === thumb));
      gallery.dataset.activeIndex = String(index);
    };
    const move = direction => {
      const current = Number(gallery.dataset.activeIndex || 0);
      renderMedia((current + direction + thumbs.length) % thumbs.length);
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => renderMedia(index)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => move(-1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => move(1));
    gallery.querySelector('[data-gallery-360]')?.addEventListener('click', event => {
      event.currentTarget.setAttribute('aria-pressed', 'true');
      event.currentTarget.textContent = '✓ 360° view';
      renderMedia(0);
    });
  }

  const variantSelector = document.querySelector('[data-variant-selector]');
  if (variantSelector) {
    const variantsScript = variantSelector.querySelector('[data-variants-json]');
    const variants = JSON.parse(variantsScript?.textContent || '[]');
    const form = document.querySelector('[data-product-form]');
    const variantId = form?.querySelector('[data-variant-id]');
    const price = document.querySelector('[data-variant-price]');
    const priceNote = document.querySelector('[data-variant-price-note]');
    const addButton = form?.querySelector('[type="submit"]');
    const optionInputs = [...variantSelector.querySelectorAll('[data-option-input]')];
    const variantGalleryThumbs = [...document.querySelectorAll('[data-gallery-thumb]')];

    const updateVariant = () => {
      const selectedOptions = [...variantSelector.querySelectorAll('[data-option-group]')].map(group => group.querySelector('[data-option-input]:checked')?.value || '');
      const variant = variants.find(item => item.options?.every((value, index) => value === selectedOptions[index]));
      if (!variant) return;

      if (variantId) variantId.value = variant.id;
      if (price) price.textContent = variant.price;
      if (priceNote) priceNote.hidden = !variant.hasCompareAtPrice;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      if (variant.mediaId) {
        const matchingThumb = variantGalleryThumbs.find(thumb => thumb.dataset.mediaId === String(variant.mediaId));
        matchingThumb?.click();
      }

      optionInputs.forEach(input => {
        const position = Number(input.dataset.optionPosition);
        const candidateOptions = [...selectedOptions];
        candidateOptions[position] = input.value;
        const hasAvailableVariant = variants.some(item => item.available && item.options?.every((value, index) => !candidateOptions[index] || value === candidateOptions[index]));
        input.disabled = !hasAvailableVariant && !input.checked;
        input.closest('label')?.classList.toggle('is-disabled', input.disabled);
      });
    };

    optionInputs.forEach(input => {
      input.dataset.optionPosition = input.closest('[data-option-group]')?.dataset.optionPosition || '';
      input.addEventListener('change', updateVariant);
    });
    updateVariant();
  }

  const details = document.querySelector('[data-product-accordion]');
  if (details && window.matchMedia('(min-width: 801px)').matches) details.open = true;
  document.querySelector('[data-scroll-details]')?.addEventListener('click', () => {
    if (details) details.open = true;
    document.querySelector('#ProductDetails')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Reviews Module Interactions & Pagination
  const reviewsContainer = document.querySelector('[data-reviews-container]');
  if (reviewsContainer) {
    let currentPage = 1;
    const totalPages = 2;
    const page1 = reviewsContainer.querySelector('[data-reviews-page="1"]');
    const page2 = reviewsContainer.querySelector('[data-reviews-page="2"]');
    const prevBtn = reviewsContainer.querySelector('[data-reviews-prev]');
    const nextBtn = reviewsContainer.querySelector('[data-reviews-next]');
    const countTop = reviewsContainer.querySelector('[data-reviews-count]');
    const countBottom = reviewsContainer.querySelector('[data-reviews-count-bottom]');
    const searchInput = reviewsContainer.querySelector('[data-reviews-search]');
    const ratingSelect = reviewsContainer.querySelector('[data-reviews-rating-select]');
    const starRows = reviewsContainer.querySelectorAll('[data-filter-stars]');
    const starBtns = reviewsContainer.querySelectorAll('.bv-star-btn');
    const allReviewCards = reviewsContainer.querySelectorAll('.bv-review-card');

    const updatePagination = (page) => {
      currentPage = page;
      if (page === 1) {
        if (page1) page1.style.display = 'flex';
        if (page2) page2.style.display = 'none';
        if (prevBtn) prevBtn.disabled = true;
        if (nextBtn) nextBtn.disabled = false;
        if (countTop) countTop.textContent = '1 – 8 of 91 Reviews';
        if (countBottom) countBottom.textContent = '1 – 8 of 91 Reviews';
      } else {
        if (page1) page1.style.display = 'none';
        if (page2) page2.style.display = 'flex';
        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = true;
        if (countTop) countTop.textContent = '9 – 16 of 91 Reviews';
        if (countBottom) countBottom.textContent = '9 – 16 of 91 Reviews';
      }
    };

    nextBtn?.addEventListener('click', () => {
      if (currentPage < totalPages) {
        updatePagination(currentPage + 1);
        reviewsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    prevBtn?.addEventListener('click', () => {
      if (currentPage > 1) {
        updatePagination(currentPage - 1);
        reviewsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    // Rating Filter
    const filterByRating = (rating) => {
      if (!rating || rating === 'all') {
        allReviewCards.forEach(card => card.style.display = '');
        updatePagination(currentPage);
        return;
      }
      // Show all pages so matching cards from both pages can be seen
      if (page1) page1.style.display = 'flex';
      if (page2) page2.style.display = 'flex';
      let visibleCount = 0;
      allReviewCards.forEach(card => {
        const cardRating = card.dataset.rating;
        const match = cardRating === String(rating);
        card.style.display = match ? '' : 'none';
        if (match) visibleCount++;
      });
      const text = `Showing ${visibleCount} reviews with ${rating} stars`;
      if (countTop) countTop.textContent = text;
      if (countBottom) countBottom.textContent = text;
      if (prevBtn) prevBtn.disabled = true;
      if (nextBtn) nextBtn.disabled = true;
    };

    ratingSelect?.addEventListener('change', (e) => filterByRating(e.target.value));

    starRows.forEach(row => {
      row.addEventListener('click', () => {
        const stars = row.dataset.filterStars;
        if (ratingSelect) ratingSelect.value = stars;
        filterByRating(stars);
      });
    });

    // Search filter
    searchInput?.addEventListener('input', (e) => {
      const query = e.target.value.toLowerCase().trim();
      if (!query) {
        filterByRating(ratingSelect ? ratingSelect.value : 'all');
        return;
      }
      if (page1) page1.style.display = 'flex';
      if (page2) page2.style.display = 'flex';
      let matchCount = 0;
      allReviewCards.forEach(card => {
        const text = card.textContent.toLowerCase();
        const matches = text.includes(query);
        card.style.display = matches ? '' : 'none';
        if (matches) matchCount++;
      });
      const text = `Showing ${matchCount} results for "${query}"`;
      if (countTop) countTop.textContent = text;
      if (countBottom) countBottom.textContent = text;
      if (prevBtn) prevBtn.disabled = true;
      if (nextBtn) nextBtn.disabled = true;
    });

    // Review this product star buttons
    starBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const star = Number(btn.dataset.star || 0);
        starBtns.forEach((b, i) => {
          b.classList.toggle('is-active', i < star);
          b.textContent = i < star ? '★' : '☆';
        });
        const note = reviewsContainer.querySelector('.bv-star-note');
        if (note) {
          note.textContent = `You selected ${star} star${star > 1 ? 's' : ''}. Verification email required to submit.`;
          note.style.color = '#e85216';
        }
      });
    });

    // Scroll to reviews button
    document.querySelectorAll('[data-scroll-reviews]').forEach(btn => {
      btn.addEventListener('click', () => {
        const reviewsAccordion = reviewsContainer.closest('details');
        if (reviewsAccordion) reviewsAccordion.open = true;
        reviewsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Helpful voting feedback
    reviewsContainer.querySelectorAll('.bv-feedback-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const span = btn.querySelector('span');
        if (span && !btn.dataset.voted) {
          span.textContent = Number(span.textContent || 0) + 1;
          btn.dataset.voted = 'true';
          btn.style.color = '#002d4b';
          btn.style.fontWeight = '700';
        }
      });
    });
  }

  // Sanitize external target links in product descriptions / page content
  document.querySelectorAll('a[href*="waterpik.com"]').forEach(a => {
    const href = a.getAttribute('href') || '';
    if (href.includes('/products/') || href.includes('/dental-water-flosser/')) {
      const parts = href.split('/').filter(Boolean);
      const slug = parts[parts.length - 1];
      a.setAttribute('href', `/products/${slug.toLowerCase()}`);
      a.removeAttribute('target');
    } else if (href.includes('replacement-parts')) {
      a.setAttribute('href', '/collections/replacement-parts');
    } else {
      a.setAttribute('href', '/pages/contact');
    }
  });

});
